import { makeActionCreator } from '../utils'

export const FETCH_INITIAL_CONFIGURATION = 'FETCH_INITIAL_CONFIGURATION'
export const fetchInitialConfiguration = makeActionCreator(
  FETCH_INITIAL_CONFIGURATION
)
